import Observable from 'zen-observable';
import 'symbol-observable';
Observable.prototype['@@observable'] = function () { return this; };
export { Observable };
//# sourceMappingURL=Observable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/observables/Observable.js
// module id = ./node_modules/@apollo/client/utilities/observables/Observable.js
// module chunks = 54 55